/**
 * SeatStepper — счётчик «число врачей» для калькуляторов тарифа (десктоп-бар
 * `sm`, edit-панель `md`, мобильная карточка `lg`). Границы — от минимума
 * мест клиники до разумного потолка.
 */

import {Minus, Plus} from 'lucide-react';

import {CLINIC_MIN_SEATS} from '@services/clients';

const SIZES = {
  sm: {btn: 'size-[34px] h-9', box: 'h-9 w-11 text-[15px]', radius: 'rounded-[9px]'},
  md: {btn: 'h-10 w-[38px]', box: 'h-10 w-12 text-base', radius: 'rounded-[9px]'},
  lg: {btn: 'size-11', box: 'h-11 w-[54px] text-lg', radius: 'rounded-[11px]'},
} as const;

type SeatStepperProps = {
  seats: number;
  setSeats: (n: number) => void;
  size?: keyof typeof SIZES;
  min?: number;
  max?: number;
};

export const SeatStepper = ({
  seats,
  setSeats,
  size = 'md',
  min = CLINIC_MIN_SEATS,
  max = 30,
}: SeatStepperProps) => {
  const s = SIZES[size];
  return (
    <div
      className={`flex items-center overflow-hidden border border-[#CBDAF6] bg-card ${s.radius}`}
    >
      <button
        onClick={() => setSeats(Math.max(min, seats - 1))}
        className={`grid ${s.btn} place-items-center border-r border-[#E4EAF7] text-primary`}
        aria-label="Меньше"
      >
        <Minus className="size-4" strokeWidth={2.2} />
      </button>
      <div className={`grid ${s.box} place-items-center font-mono font-semibold`}>{seats}</div>
      <button
        onClick={() => setSeats(Math.min(max, seats + 1))}
        className={`grid ${s.btn} place-items-center border-l border-[#E4EAF7] text-primary`}
        aria-label="Больше"
      >
        <Plus className="size-4" strokeWidth={2.2} />
      </button>
    </div>
  );
};
